<script setup>
import { computed } from 'vue';
import Avatar from 'next/avatar/Avatar.vue';
import { useI18n } from 'vue-i18n';

import Button from 'dashboard/components-next/button/Button.vue';

const props = defineProps({
  macro: {
    type: Object,
    required: true,
  },
});
defineEmits(['delete']);
const { t } = useI18n();

const createdByName = computed(() => {
  const createdBy = props.macro.created_by;
  return createdBy.available_name ?? createdBy.email ?? '';
});

const updatedByName = computed(() => {
  const updatedBy = props.macro.updated_by;
  return updatedBy.available_name ?? updatedBy.email ?? '';
});

const visibilityLabel = computed(() => {
  const i18nKey =
    props.macro.visibility === 'global'
      ? 'MACROS.EDITOR.VISIBILITY.GLOBAL.LABEL'
      : 'MACROS.EDITOR.VISIBILITY.PERSONAL.LABEL';
  return t(i18nKey);
});
</script>

<template>
  <tr class="macro-row">
    <td class="macro-td truncate">{{ macro.name }}</td>
    <td class="macro-td">
      <div v-if="macro.created_by" class="flex items-center gap-2">
        <Avatar :name="createdByName" :size="24" rounded-full />
        <span>{{ createdByName }}</span>
      </div>
      <div v-else>--</div>
    </td>
    <td class="macro-td">
      <div v-if="macro.updated_by" class="flex items-center gap-2">
        <Avatar :name="updatedByName" :size="24" rounded-full />
        <span>{{ updatedByName }}</span>
      </div>
      <div v-else>--</div>
    </td>
    <td class="macro-td">{{ visibilityLabel }}</td>
    <td class="macro-td">
      <div class="flex justify-end gap-1">
        <router-link
          :to="{ name: 'macros_edit', params: { macroId: macro.id } }"
        >
          <Button
            v-tooltip.top="$t('MACROS.EDIT.TOOLTIP')"
            icon="i-lucide-pen"
            slate
            xs
            faded
          />
        </router-link>
        <Button
          v-tooltip.top="$t('MACROS.DELETE.TOOLTIP')"
          icon="i-lucide-trash-2"
          xs
          ruby
          faded
          @click="$emit('delete')"
        />
      </div>
    </td>
  </tr>
</template>

<style scoped>
.macro-row {
  border-bottom: 1px solid #f3f4f6;
  background: #ffffff;
  transition: background 0.12s ease;
}

.macro-row:last-child {
  border-bottom: none;
}

.macro-row:hover {
  background: #fafafa;
}

.macro-td {
  padding: 14px 24px;
  font-size: 13px;
  color: #111827;
  vertical-align: middle;
}
</style>
